import { useCallback, useRef, useState } from "react";

const useMousePosition = () => {
  const [mousePosition, setMousePosition] = useState({
    left: 0,
    top: 0,
  });
  // #region set mouse position
  const handleMouseMove = useCallback(
    (e) =>
      setMousePosition({
        left: e.pageX,
        top: e.pageY,
      }),
    []
  );
  //#endregion
  const ref = useRef();

  //#region add event listener for mouse movement
  const callbackRef = useCallback(
    (node) => {
      if (ref.current) {
        ref.current.removeEventListener("mousemove", handleMouseMove);
      }
      ref.current = node;
      if (ref.current) {
        ref.current.addEventListener("mousemove", handleMouseMove);
      }
    },
    [handleMouseMove]
  );
  //#endregion

  return [callbackRef, mousePosition];
};

export default useMousePosition;
